var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5353 6.8684C7.99073 6.2898 7.34254 5.86146 6.63534 5.60217C7.39278 5.04787 7.8904 4.12021 7.8904 3.07125C7.8904 1.37777 6.5937 0 4.99986 0C3.40602 0 2.10931 1.37777 2.10931 3.07125C2.10931 4.12021 2.60694 5.04787 3.3644 5.60217C2.65719 5.86146 2.009 6.2898 1.46443 6.8684C0.520083 7.8718 0 9.20587 0 10.6249H0.781228C0.781228 8.15328 2.67369 6.1425 4.99986 6.1425C7.32602 6.1425 9.21848 8.15328 9.21848 10.6249H9.99971C9.99971 9.20587 9.47963 7.8718 8.5353 6.8684ZM4.99986 5.31244C3.83678 5.31244 2.89054 4.30706 2.89054 3.07125C2.89054 1.83545 3.83678 0.830068 4.99986 0.830068C6.16293 0.830068 7.10917 1.83545 7.10917 3.07125C7.10917 4.30706 6.16293 5.31244 4.99986 5.31244Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5926C10 10.8176 9.82544 11 9.6101 11C9.39477 11 9.22021 10.8176 9.22021 10.5926C9.22021 10.3676 9.39477 10.1852 9.6101 10.1852C9.82544 10.1852 10 10.3676 10 10.5926Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.779791 10.5926C0.779791 10.8176 0.605229 11 0.389896 11C0.174562 11 0 10.8176 0 10.5926C0 10.3676 0.174562 10.1852 0.389896 10.1852C0.605229 10.1852 0.779791 10.3676 0.779791 10.5926Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.f28350fedd27a067e2fb21ceac84652e.svg";
export { ForwardRef as ReactComponent };